/**
 * Forward geocode for US — institution name, address, or place.
 * Uses Mapbox when REACT_APP_MAPBOX_API is set; otherwise OpenStreetMap Nominatim (usage policy: light use, identify app).
 */

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_API;

/**
 * @param {string} query
 * @returns {Promise<{ lat: number, lng: number, label: string }>}
 */
export async function geocodeUsSearch(query) {
  const q = typeof query === "string" ? query.trim() : "";
  if (!q) {
    const err = new Error("Enter an address, hospital name, or place.");
    err.code = "EMPTY";
    throw err;
  }

  if (MAPBOX_TOKEN) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
      q
    )}.json?access_token=${MAPBOX_TOKEN}&country=us&limit=1`;
    const res = await fetch(url);
    if (!res.ok) throw new Error("Search failed. Try again.");
    const data = await res.json();
    const f = data.features?.[0];
    if (!f?.center || !Array.isArray(f.center)) {
      throw new Error("No results in the US. Try a different search.");
    }
    return {
      lat: f.center[1],
      lng: f.center[0],
      label: f.place_name || q,
    };
  }

  const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
    q
  )}&countrycodes=us&limit=1`;
  const res = await fetch(url, {
    headers: {
      Accept: "application/json",
      "Accept-Language": "en",
      "User-Agent": "HealthDeskZipCollection/1.0 (internal map picker; contact: support per app)",
    },
  });
  if (!res.ok) throw new Error("Search failed. Try again.");
  const arr = await res.json();
  const hit = arr?.[0];
  if (!hit?.lat || !hit?.lon) {
    throw new Error("No results in the US. Try a different search.");
  }
  return {
    lat: Number(hit.lat),
    lng: Number(hit.lon),
    label: hit.display_name || q,
  };
}
